import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Checkbox } from '@node-space/ui-components'

interface RewardsTermsCheckboxProps {
  disabled?: boolean
}

export const RewardsTermsCheckbox = ({ disabled = false }: RewardsTermsCheckboxProps) => {
  const { control } = useFormContext()
  const { t } = useTranslation()

  return (
    <Controller
      name="termsAccepted"
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <Checkbox
          id="terms-checkbox"
          name="terms"
          testId="terms-checkbox"
          label={`${t('rewards.deposit.acceptTermsAndConditions')} {{link}}`}
          labelLinks={{
            link: {
              href: process.env.REWARDS_TERMS_URL,
              text: t('rewards.deposit.termsAndConditionsLink'),
              target: '_blank',
            },
          }}
          checked={value}
          onCheckedChange={checked => onChange(checked)}
          disabled={disabled}
          error={!!error?.message}
          errorText={error?.message}
        />
      )}
    />
  )
}
